import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedReceiptDateRange: [],
    allCurrencies: [],
    allCompanies: [],
    pairingRate: [],
    receiptData: null,
    isReceiptLoading: false,
    page: 0,
    rowsPerPage: 10,
    sort: {
        keytoSort: "",
        direction: "desc",
    },
    selectedReceiptNumber:[],
    selectedCompany:[],
    selectedFME: [],
    selectedDate: null,
    selectedStatus: [],
    selectedAccount: [],
    selectedPercentCovered: [],
    selectedRow:[],
    selectedReceipt: []
}

const financeReceiptSlice = createSlice({
    name: "receipts",
    initialState,
    reducers: {
        setSelectedReceiptDateRange: (state, action) => {
            state.selectedReceiptDateRange = action.payload;
        },
        setAllCurrencies: (state, action) => {
            state.allCurrencies = action.payload;
        },
        setAllCompanies: (state, action) => {
            state.allCompanies = action.payload;
        },
        setPairingRate: (state, action) => {
            state.pairingRate = action.payload;
        },
        setReceiptData: (state, action) => {
            state.receiptData = action.payload;
        },
        setIsReceiptLoading: (state, action) => {
            state.isReceiptLoading = action.payload;
        },
        setPage: (state, action) => {
            state.page = action.payload;
        },
        setRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload;
        },
        setSort: (state, action) => {
            state.sort = action.payload;
        },
        setSelectedReceiptNumber: (state, action) => {
            state.selectedReceiptNumber = action.payload;
        },
        setSelectedCompany: (state, action) => {
            state.selectedCompany = action.payload;
        },
        setSelectedFME: (state, action) => {
            state.selectedFME = action.payload;
        },
        setSelectedDate: (state, action) => {
            state.selectedDate = action.payload;
        },
        setSelectedStatus: (state, action) => {
            state.selectedStatus = action.payload;
        },
        setSelectedAccount: (state, action) => {
            state.selectedAccount = action.payload;
        },
        setSelectedPercentCovered: (state, action) => {
            state.selectedPercentCovered = action.payload;
        },
        setSelectedRow: (state, action) => {
            state.selectedRow = action.payload;
        },
        setSelectedReceipt: (state, action) => {
            state.selectedReceipt = action.payload;
        },
    }
});

export const {
    setSelectedReceiptDateRange,
    setAllCurrencies,
    setAllCompanies,
    setPairingRate,
    setReceiptData,
    setIsReceiptLoading,
    setPage,
    setRowsPerPage,
    setSort,
    setSelectedReceiptNumber,
    setSelectedCompany,
    setSelectedFME,
    setSelectedDate,
    setSelectedStatus,
    setSelectedAccount,
    setSelectedPercentCovered,
    setSelectedRow,
    setSelectedReceipt,
} = financeReceiptSlice.actions;

export default financeReceiptSlice.reducer;

